export default __webpack_public_path__ + "static/media/2.3a4bca2e.jpg";